import { http } from "./http";
export type Conference = {
  state: string;
  provider: "GOOGLE" | "MANUAL" | null;
  url: string | null;
  canManage: boolean;
  cancelled: boolean;
};
export const googleMeetApi = {
  status: async () =>
    (
      await http.get<{
        configured: boolean;
        connected: boolean;
        email: string | null;
      }>("/v1/google-calendar")
    ).data,
  connect: async () =>
    (await http.post<{ url: string }>("/v1/google-calendar/connect")).data,
  disconnect: async () =>
    (
      await http.post<{ remoteRevoked: boolean }>(
        "/v1/google-calendar/disconnect",
      )
    ).data,
  callback: async (state: string, code: string) =>
    (await http.post("/v1/google-calendar/callback", { state, code })).data,
  get: async (id: string) =>
    (await http.get<Conference>("/v1/meeting-conferences/" + id)).data,
  action: async (
    id: string,
    action: "google" | "manual" | "cancel",
    version: number,
    url?: string,
  ) =>
    (
      await http.post<Conference>(
        "/v1/meeting-conferences/" + id + "/" + action,
        { version, ...(url ? { url } : {}) },
      )
    ).data,
  upcoming: async () =>
    (
      await http.get<{ id: string; title: string; startsAt: string }[]>(
        "/v1/meeting-conferences/upcoming",
      )
    ).data,
};
